import React from 'react';
import { motion } from 'framer-motion';
import { Clock } from 'lucide-react';
export function Urgency() {
  return <section className="py-24 px-6 bg-blush/30 text-ink" data-id="element-289">
      <div className="max-w-3xl mx-auto text-center" data-id="element-290">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-291">
          <Clock className="mx-auto text-gold-dark mb-6" size={40} data-id="element-292" />
          <h2 className="text-3xl md:text-5xl font-serif text-ink-dark mb-8" data-id="element-293">
            Los turnos de Ingri se llenan rápido. Y por una razón.
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="space-y-6 font-sans text-lg text-ink-light" data-id="element-294">
          <p data-id="element-295">
            No trabaja en cadena. No apresura a sus clientas. Cada cita tiene su
            tiempo. Su dedicación. Su arte.
          </p>
          <p className="text-xl font-serif text-gold-dark italic" data-id="element-296">
            Por eso hay lista de espera.
          </p>
          <p className="font-bold text-ink-dark bg-white py-4 px-6 rounded-sm inline-block mt-4 shadow-sm border border-gold/20" data-id="element-297">
            Si estás viendo esto, hay un turno disponible. Mañana puede que no.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto" data-id="element-298">
          <div className="bg-white/60 backdrop-blur-sm p-8 border border-gold/20 rounded-sm flex items-center justify-center" data-id="element-299">
            <p className="font-serif text-xl text-ink-dark italic" data-id="element-300">
              "Atrévete a mirar al mundo con intensidad... y con estilo."
            </p>
          </div>
          <div className="bg-white/60 backdrop-blur-sm p-8 border border-gold/20 rounded-sm flex items-center justify-center" data-id="element-301">
            <p className="font-serif text-xl text-ink-dark italic" data-id="element-302">
              "Lashista por amor, experta por dedicación: pestañas que
              inspiran."
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}